import { gql, useQuery } from "@apollo/client";

const GET_FEATURES_TOGGLE = gql`
  query getFeatuesToggle($starts_with: Text!, $org_name: Text!) {
  organisationSettings(
    where: {settingName: {starts_with: $starts_with}, organisation: {name: {_eq: $org_name}}}
    order_by: {settingName: Asc}
  ) {
    settingName
    settingValue
    organisationId
    id
  }
}
`;

export function useFeaturesToggle(orgName) {
  const { data, loading, error, refetch } = useQuery(GET_FEATURES_TOGGLE,
    {
      context: {
        headers: {
          'x-hasura-role': 'learner'
        }
      },
      variables: {
        starts_with: 'features',
        org_name: orgName
      },
      skip: !orgName
    }
  );

  return { data: data?.organisationSettings, loading, error, refetch };
};
